/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {

  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showProgressBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public currentProgressForProgressbar: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor() { }

  display(value: boolean) {
    this.status.next(value);
  }

  displayProgressBar(value: boolean) {
    this.showProgressBar.next(value);
  }

  setProgresForProgressBar(value: number) {
    this.currentProgressForProgressbar.next(value);
  }

  getProgressBarDisplayStatus() {
    return this.showProgressBar.value;
  }

}
